import ImportGeneric from "./ImportGeneric";

export { ImportVCard as default };

/**
* VCard Parse
*
* Handler all data from file import contacts
*
* @author      brunorbarroso <bruno-b-rodrigues@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ImportVCard extends ImportGeneric {

  /**
   * Regex to validate VCard file
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  regex = /(^BEGIN:VCARD)/;

  /**
   * Contacts Config Parse from VCard type
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  fields = {
    lastname : {
      keys: ['FN'],
    },
    email : {
      keys: ['EMAIL'],
    },
    cellPhone : {
      keys: ['TEL'],
    },
    homeStreet : {
      keys: ['ADR'],
      transform: function(adr){
        let delimiter = adr.includes(";") ? ";" : ",";

        adr = adr.replace(/\\n/g, delimiter);

        let adr_array = adr.split(delimiter);

        adr_array = adr_array.map(item => item.trim());

        let unique_adr_array = [...new Set(adr_array)].filter(item => item !== "");

        let formatted = unique_adr_array.join(", ");

        return formatted;
      }
    },
    birthday : {
      keys: ['BDAY'],
      transform: function(date){
        if(date && !date.includes('-')){
          date = date.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
        }

        return date;
      }
    },
    company : {
      keys: ['ORG']
    },
    notes : {
      keys: ['NOTE']
    }
  }

  /**
   * Constructor 
   * 
   * @param {String} content 
   */
   constructor(content) {
    super(content);
    this.setContent(content);
  }

  /**
   * Method to save contacts correctly 
   * 
   * @param {String} content
   * @return {void} 
   */
  setContent(content) {
    this.content = this.parse(content);
  }

  /**
   * Parse the raw of the contacts vcard
   * @param {String} content
   * @returns {String}
   */
  parse(content) {
    const vcards = this.extractVCards(content);
    const contacts = vcards.map(vcard => this.parseVCard(vcard));

    return contacts;
  }

  /**
   * extracts the lines of each contact from the vcard
   * @param {String} content
   * @returns {Array}
   */
  extractVCards(content) {
    const regex = /BEGIN:VCARD([\s\S]*?)END:VCARD/gm;
    const matches = content.matchAll(regex);
    const vcards = [];

    for (const match of matches) {
      const vcard = match[1];
      vcards.push(vcard);
    }

    return vcards;
  }

  /**
   * formats each object of the contact by placing it in the default
   * vcard 3.0 being FN, N, TEL, and etc..
   * Also adds an array if there is multiple data
   * example EMAIL, TEL, ADR and others that exist.
   *
   * @param {String} vcard
   * @returns {Object}
   */
  parseVCard(vcard) {
    const rows = vcard.split('\n');
    const contact = {};

    rows.forEach(row => {
      if (!row) return;

      const [row_field, row_value] = row.split(':');
      const index_field = this.formatIndexFieldVCard(row_field);

      if (!['BEGIN', 'END', 'VERSION'].includes(row_field)) {
        if (this.indexVCardHasType(row_field)) {
          const [field, type] = row_field.split(';');
          if (!contact[index_field]) {
            contact[index_field] = [];
          }
          contact[index_field].push({ [type]: row_value });
        } else {
          contact[index_field] = row_value;
        }
      }
    });

    return contact;
  }

  /**
   * Checks if the vcard index has the TYPE
   * as a complementary attribute.
   *
   * @param {*} field
   * @returns
   */
  indexVCardHasType(field) {
    return field.includes('TYPE');
  }

  /**
   * Returns the index of the formatted vcard keeping
   * just the vcard 3.0 keyword
   *
   * (?: ... ) - grupo nao capturado
   * [^.\n]+ que nao sejam pontos seguidos de ponto \.
   * repetidos zero ou mais vezes *
   * ([A-Z]+) - grupo capturado que seria grupo principal
   * (?:;.*)? - grupo nao capturado apos o grupo principal
   *
   * @param {*} field
   * @returns
   */
  formatIndexFieldVCard(field) {
    const regex = /^(?:[^.\n]+\.)*([A-Z]+)(?:;.*)?$/;
    const match = field.match(regex);

    if (match) {
      return match[1];
    }

    return field;
  }

  /**
   * 
   * @param {Object} item contact object
   * @param {Array} keys list of keys to search in object
   * @returns {String} content from object
   */
  getValueByKey(items, key, field) {
    let item_data = items[key] || null;

    if(!item_data) return '';

    if(Array.isArray(item_data)){
      item_data = Object.values(item_data[0])[0] || '';
    }

    if(field.transform){
      item_data = field.transform(item_data);
    }

    return item_data;
  }
}